var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "createTemplateModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("admin.create_template"),
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createTemplate()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.create")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-1",
            label: this.$t("message.name"),
            "label-for": "input-1",
            "label-class": "required",
          },
        },
        [
          _c("b-form-input", {
            staticClass: "required",
            attrs: { id: "input-1", required: "", trim: "" },
            model: {
              value: _vm.name,
              callback: function ($$v) {
                _vm.name = $$v
              },
              expression: "name",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-2",
            label: this.$t("admin.publisher_class"),
            "label-for": "input-2",
            "label-class": "required",
          },
        },
        [
          _c("b-form-input", {
            staticClass: "required",
            attrs: { id: "input-2", required: "", trim: "" },
            model: {
              value: _vm.publisherClass,
              callback: function ($$v) {
                _vm.publisherClass = $$v
              },
              expression: "publisherClass",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-3",
            label: this.$t("message.description"),
            "label-for": "input-3",
            "label-class": "required",
          },
        },
        [
          _c("b-form-textarea", {
            staticClass: "required",
            attrs: { id: "input-3", rows: "4", required: "", trim: "" },
            model: {
              value: _vm.description,
              callback: function ($$v) {
                _vm.description = $$v
              },
              expression: "description",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-4",
            label: this.$t("admin.mime_type"),
            "label-for": "input-4",
            "label-class": "required",
          },
        },
        [
          _c("b-form-input", {
            staticClass: "required",
            attrs: { id: "input-4", required: "", trim: "" },
            model: {
              value: _vm.mimeType,
              callback: function ($$v) {
                _vm.mimeType = $$v
              },
              expression: "mimeType",
            },
          }),
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "fieldset-5",
            label: this.$t("admin.template"),
            "label-for": "input-5",
            "label-class": "required",
          },
        },
        [
          _c("b-form-textarea", {
            staticClass: "required",
            attrs: { id: "input-5", rows: "10", required: "", trim: "" },
            model: {
              value: _vm.template,
              callback: function ($$v) {
                _vm.template = $$v
              },
              expression: "template",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }